// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AssessmentModule } from '../../../../../types/Model';

import { S } from './styles';

interface AssessmentEpilogueProps {
  name: AssessmentModule['name'];
  handleRestartAssessment: () => void;
  handleNextModule: () => void;
  correctQuestions: number;
  totalQuestions: number;
}

const Epilogue: React.FC<AssessmentEpilogueProps> = ({
  handleRestartAssessment,
  handleNextModule,
  name,
  correctQuestions,
  totalQuestions
}):JSX.Element => {
  return (
    <S.Container>
      <S.Row>
        <S.InformationContainer>
          <S.Title>{name}</S.Title>
          <S.DetailsRow>
            <S.DetailsTitle><FormattedMessage id="F035" /></S.DetailsTitle>
            <S.Row style={{ alignItems: 'baseline' }}>
              <S.DetailsText>
                <FormattedMessage id="F036"
                  values={{
                    correctQuestions,
                    totalQuestions
                  }}/>
              </S.DetailsText>
              <S.DetailsText><FormattedMessage id="F037" /></S.DetailsText>
              <S.ScoreText>{Math.round(correctQuestions/totalQuestions * 100)}%</S.ScoreText>
            </S.Row>
          </S.DetailsRow>
        </S.InformationContainer>
      </S.Row>
      <S.Row>
        <S.TextButton onClick={handleRestartAssessment}><FormattedMessage id="F038" /></S.TextButton>
        <S.Button onClick={handleNextModule}><FormattedMessage id="F039" /></S.Button>
      </S.Row>
    </S.Container>
  );
}

export { Epilogue as default };
